export default __webpack_public_path__ + "media/6d13fc6e09d9c545e1a6ad99e9b12662f232601c428a0be239bef169a48247ff.svg";